<template>
  <div
    :class="['search-card', {
      'selected': isSelected,
    }]"
    @click="onClick">
    <div class="inner-card">
      <img :src="iconSrc" alt="Entertainment Icon" class="card-icon-cat" />
      <p class="card-title-cat">{{displayLabel}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardComponent",
    props: {
      isSelected: {
        type: Boolean,
        default: false,
      },
      iconSrc: {
        type: String,
        required: true,
      },
      displayLabel: {
        type: String,
        required: true
      }
    },
    methods: {
      onClick() {
        this.$emit('click');
      },
    }
};
</script>

<style scoped lang="scss">
@import '../assets/styles/breakpoints.scss';

.search-card {
  position: relative;
  background: white;
  border-radius: 25px;
  border: 6px solid rgba(8, 151, 216, 0.44);
  cursor: pointer;
  overflow: hidden;
  
  & * {
    box-sizing: border-box;
  }

  &::after {
    display: block;
    padding-top: 120%;
    content: '';
  }

  @media (orientation: portrait) {
    width: 86px;
    margin: 10px 0;

    @media (min-width: $breakpoint-sm) {
      width: 140px;
    }

    @media (min-width: $breakpoint-md) {
      width: 180px;
    }
  }

  @media (orientation: landscape) {
    flex: 0 0 86px;

    @media (min-width: $breakpoint-xs) {
      flex: 0 0 90px;
    }

    @media (min-width: $breakpoint-sm) {
      flex: 0 0 95px;
    }

    @media (min-width: $breakpoint-md) {
      flex: 0 0 130px;
    }

    @media (min-width: $breakpoint-lg) {
      flex: 0 0 160px;
    }
  }

  @media (min-width: $breakpoint-lg) {
    &:focus,
    &:hover {
      .inner-card {
        opacity: 0.9;
      }
    }
  }

  &.selected {
    border: 5px solid #29b6f6 !important;
    box-shadow: 0px 0px 15px 3px rgba(41, 182, 246, 0.8);

    .inner-card {
      border-width: 3px;
    }
  }

  .inner-card {
    position: absolute;
    background-color: white;
    top: 0;
    left: 0;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    z-index: 2;
    img {
      display: block;
      @media (max-width: $breakpoint-md) {
        margin-bottom: 2px;
        height: 50px;
      }
    }
  }
}
.card-title-cat {
  font-size: 14px;
  color: #000;
  font-family: 'Nunito-ExtraBold';
  text-align: center;

  @media (min-width: $breakpoint-lg) {
    font-weight: bold;
    margin-block: 10px;
  }
  @media (max-width: $breakpoint-sm) {
    margin-block: 5px;
  }
  @media (orientation: landscape) and (min-width: $breakpoint-sm) {
    margin-block: 2px;
  }
}
</style>
